// Helpers
import { getDepartmentalPosition, supportedSystemPositions } from "@/Common/helpers/Positions";

// System positions
const POSITIONS = supportedSystemPositions();

// Icons
import A from "@/assets/icons/positions/A.svg";
import FD from "@/assets/icons/positions/FD.svg";
import FM from "@/assets/icons/positions/FM.svg";
import GM from "@/assets/icons/positions/GM.svg";
import GSM from "@/assets/icons/positions/GSM.svg";
import M from "@/assets/icons/positions/M.svg";
import PD from "@/assets/icons/positions/PD.svg";
import PM from "@/assets/icons/positions/PM.svg";
import SA from "@/assets/icons/positions/SA.svg";
import SD from "@/assets/icons/positions/SD.svg";
import SF from "@/assets/icons/positions/SF.svg";
import SM from "@/assets/icons/positions/SM.svg";
import ST from "@/assets/icons/positions/ST.svg";
import PC from "@/assets/icons/positions/PCA.svg";
import BDCM from "@/assets/icons/positions/BDCM.svg";
import BDCSA from "@/assets/icons/positions/BDCSA.svg";
import BDCS from "@/assets/icons/positions/BDCS.svg";
import BSM from "@/assets/icons/positions/BSM.svg";
import BSP from "@/assets/icons/positions/BSP.svg";
import BSPM from "@/assets/icons/positions/BSPM.svg";
import BSF from "@/assets/icons/positions/BSF.svg";
import BST from "@/assets/icons/positions/BST.svg";
import BSE from "@/assets/icons/positions/BSE.svg";
import ISA from "@/assets/icons/positions/ISA.svg";

// Outlined Icons
import SalesAssociate from "@/assets/icons/outlinedPositions/SalesAssociate.svg";
import SalesManager from "@/assets/icons/outlinedPositions/SalesManager.svg";
import GeneralManager from "@/assets/icons/outlinedPositions/GeneralManager.svg";
import GeneralSalesManager from "@/assets/icons/outlinedPositions/GeneralSalesManager.svg";
import FinanceDirector from "@/assets/icons/outlinedPositions/FinanceDirector.svg";
import FinanceManager from "@/assets/icons/outlinedPositions/FinanceManager.svg";
import BDCSalesAssociate from "@/assets/icons/outlinedPositions/BDCSalesAssociate.svg";
import BDCService from "@/assets/icons/outlinedPositions/BDCService.svg";
import BDCManager from "@/assets/icons/outlinedPositions/BDCManager.svg";
import ServiceTechnician from "@/assets/icons/outlinedPositions/ServiceTechnician.svg";
import ServiceAdvisor from "@/assets/icons/outlinedPositions/ServiceAdvisor.svg";
import ServiceForeman from "@/assets/icons/outlinedPositions/ServiceForeman.svg";
import ServiceManager from "@/assets/icons/outlinedPositions/ServiceManager.svg";
import ServiceDirector from "@/assets/icons/outlinedPositions/ServiceDirector.svg";
import InternalServiceAdvisors from "@/assets/icons/outlinedPositions/InternalServiceAdvisor.svg";
import BodyShopManager from "@/assets/icons/outlinedPositions/BodyShopManager.svg";
import BodyShopProdManager from "@/assets/icons/outlinedPositions/BodyShopProdManager.svg";
import BodyShopTechnician from "@/assets/icons/outlinedPositions/BodyShopTechnician.svg";
import BodyShopPainter from "@/assets/icons/outlinedPositions/BodyShopPainter.svg";
import BodyShopEstimator from "@/assets/icons/outlinedPositions/BodyShopEstimator.svg";
import BodyShopForeman from "@/assets/icons/outlinedPositions/BodyShopForeman.svg";
import PartsCounterAssociate from "@/assets/icons/outlinedPositions/PartsCounterAssociate.svg";
import PartsManager from "@/assets/icons/outlinedPositions/PartsManager.svg";
import PartsDirector from "@/assets/icons/outlinedPositions/PartsDirector.svg";

const ICONS = new Map([
	// CORPORATE
	[POSITIONS.LOCATION.GENERAL_MANAGER, GM],

	// SALES
	[POSITIONS.SALES.SALES_ASSOCIATE, A],
	[POSITIONS.SALES.SALES_MANAGER, M],
	[POSITIONS.SALES.GENERAL_SALES_MANAGER, GSM],

	// FINANCE
	[POSITIONS.FINANCE.FINANCE_MANAGER, FM],
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, FD],

	// BDC
	[POSITIONS.BDC.BDC_SALES_ASSOCIATE, BDCSA],
	[POSITIONS.BDC.BDC_SERVICE_ASSOCIATE, BDCS],
	[POSITIONS.BDC.BDC_MANAGER, BDCM],

	// BODY SHOP
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER, BSM],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER, BSPM],
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN, BSF],
	[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN, BST],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER, BSP],
	[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR, BSE],

	// SERVICE
	[POSITIONS.SERVICE.SERVICE_MANAGER, SM],
	[POSITIONS.SERVICE.SERVICE_FOREMAN, SF],
	[POSITIONS.SERVICE.SERVICE_TECHNICIAN, ST],
	[POSITIONS.SERVICE.SERVICE_ADVISOR, SA],
	[POSITIONS.SERVICE.SERVICE_DIRECTOR, SD],
	[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR, ISA],

	// PARTS
	[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE, PC],
	[POSITIONS.PARTS.PARTS_MANAGER, PM],
	[POSITIONS.PARTS.PARTS_DIRECTOR, PD],
]);

// Constants
const OUTLINED_ICONS = new Map([
	// CORPORATE
	[POSITIONS.LOCATION.GENERAL_MANAGER, GeneralManager],

	// SALES
	[POSITIONS.SALES.SALES_ASSOCIATE, SalesAssociate],
	[POSITIONS.SALES.SALES_MANAGER, SalesManager],
	[POSITIONS.SALES.GENERAL_SALES_MANAGER, GeneralSalesManager],

	// FINANCE
	[POSITIONS.FINANCE.FINANCE_MANAGER, FinanceManager],
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, FinanceDirector],

	// BDC
	[POSITIONS.BDC.BDC_SALES_ASSOCIATE, BDCSalesAssociate],
	[POSITIONS.BDC.BDC_SERVICE_ASSOCIATE, BDCService],
	[POSITIONS.BDC.BDC_MANAGER, BDCManager],

	// BODY SHOP
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER, BodyShopManager],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER, BodyShopProdManager],
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN, BodyShopForeman],
	[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN, BodyShopTechnician],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER, BodyShopPainter],
	[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR, BodyShopEstimator],

	// SERVICE
	[POSITIONS.SERVICE.SERVICE_MANAGER, ServiceManager],
	[POSITIONS.SERVICE.SERVICE_FOREMAN, ServiceForeman],
	[POSITIONS.SERVICE.SERVICE_TECHNICIAN, ServiceTechnician],
	[POSITIONS.SERVICE.SERVICE_ADVISOR, ServiceAdvisor],
	[POSITIONS.SERVICE.SERVICE_DIRECTOR, ServiceDirector],
	[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR, InternalServiceAdvisors],

	// PARTS
	[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE, PartsCounterAssociate],
	[POSITIONS.PARTS.PARTS_MANAGER, PartsManager],
	[POSITIONS.PARTS.PARTS_DIRECTOR, PartsDirector],
]);

const getPositionIcon = (props: { position: string }): string => {
	const { position } = props;
	const departmental = getDepartmentalPosition(position);
	return ICONS.get(departmental) ?? "";
};

const getOutlinedPositionIcon = (props: { position: string }): string => {
	const { position } = props;
	const departmental = getDepartmentalPosition(position);
	return OUTLINED_ICONS.get(departmental) ?? "";
};

export { getPositionIcon, getOutlinedPositionIcon };
